import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import tenantPickerMixin from './pickerMixin';
import { mapState } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'CoreTenantDetails',
  mixins: [tenantPickerMixin],
  model: {
    event: 'modified'
  },
  props: {
    // the tenant to be edited
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    referenceTenant: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      valid: false,
      panel: null,
      isCreatingNewTenant: false,
      isLoading: false,
      defaultPasswordPolicy: {},
      lclModel: {
        name: null,
        data: {
          email: {
            defaults: {}
          },
          passwordPolicy: {},
          serviceBuilderUrl: null
        }
      },
      tenantDetails: {
        ancestors: []
      },
      tenantParentId: -1,
      tenantSwitchPrompt: false,
      tenantSwitchId: -1,
      passwordLengthRule: [function (v) {
        return !!v && !isNaN(parseInt(v)) && parseInt(v) >= _this.defaultPasswordPolicy.length || _this.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', _this.defaultPasswordPolicy.length, {
          n: _this.defaultPasswordPolicy.length
        });
      }],
      serviceBuilderParams: null,
      serviceBuilderPanel: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    requiredRule: function requiredRule() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('Common.fieldRequired');
      }];
    },
    tenantDates: function tenantDates() {
      moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language); // Use moment now that the locale has been properly set.

      var createdAt = moment(this.lclModel.createdAt).format('LLLL');
      var updatedAt = moment(this.lclModel.updatedAt).format('LLLL');
      return {
        createdAt: createdAt,
        updatedAt: updatedAt
      };
    },
    tenantDomains: function tenantDomains() {
      return get(this.lclModel, 'data.theme.domains');
    },
    requiredEmailFieldsAreEmpty: function requiredEmailFieldsAreEmpty() {
      return !this.lclModel.data.email.emailAddress && !this.lclModel.data.email.serverAddress && !this.lclModel.data.email.serverPort && !this.lclModel.data.email.serverUser && !this.lclModel.data.email.serverPassword && this.lclModel.data.email.secure === undefined && this.lclModel.data.email.ignoreTLS === undefined && this.lclModel.data.email.rejectUnauthorized === undefined;
    },
    validateEmailSettings: function validateEmailSettings() {
      var _this3 = this;

      return function (value) {
        return _this3.requiredEmailFieldsAreEmpty ? !value : !!value;
      };
    },
    newTenantParentName: function newTenantParentName() {
      var _this4 = this;

      return (this.tenants.find(function (t) {
        return t.id === _this4.tenantParentId;
      }) || {}).name;
    }
  }),
  watch: {
    value: function value() {
      var _this5 = this;

      return this.fetchTenant().then(function () {
        return _this5.createInitialData();
      });
    },
    tenantParentId: function tenantParentId() {
      this.lclModel.newParentId = this.tenantParentId;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return this.fetchTenant().then(function () {
      return _this6.createInitialData();
    });
  },
  methods: {
    cloneDeep: cloneDeep,
    get: get,
    set: set,
    clearEmailSettings: function clearEmailSettings() {
      this.lclModel.data.email.emailAddress = undefined;
      this.lclModel.data.email.serverAddress = undefined;
      this.lclModel.data.email.serverPort = undefined;
      this.lclModel.data.email.serverUser = undefined;
      this.lclModel.data.email.serverPassword = undefined;
      this.lclModel.data.email.secure = undefined;
      this.lclModel.data.email.ignoreTLS = undefined;
      this.lclModel.data.email.rejectUnauthorized = undefined;
    },
    updateEmailSwitchToggle: function updateEmailSwitchToggle(e, item) {
      this.lclModel.data.email[item] = e;
      this.lclModel.data.email = cloneDeep(this.lclModel.data.email);
      this.revalidateForm();
    },
    revalidateForm: function revalidateForm() {
      this.$refs && this.$refs.form ? this.$refs.form.validate() : null;
    },
    updateDomains: function updateDomains(domains) {
      set(this.lclModel, 'data.theme.domains', domains);
    },
    openLink: function openLink() {
      window.open(this.lclModel.data.serviceBuilderUrl);
    },
    validate: function validate() {
      this.valid = this.$refs && this.$refs.form ? this.$refs.form.validate() : false;

      if (this.valid) {
        this.snackbar = true;
      }

      return this.valid;
    },
    createInitialData: function createInitialData() {
      if (this.value && this.value.id) {
        this.lclModel = cloneDeep(this.value);
      }

      set(this.lclModel, 'data', get(this.lclModel, 'data', {}));
      set(this.lclModel, 'data.email', get(this.lclModel, 'data.email', {
        defaults: {}
      }));
      set(this.lclModel, 'data.passwordPolicy', _objectSpread(_objectSpread({}, this.defaultPasswordPolicy), get(this.lclModel, 'data.passwordPolicy', this.defaultPasswordPolicy)));
      this.createInitialUserDefaultProperties();
    },
    createInitialUserDefaultProperties: function createInitialUserDefaultProperties() {
      if (get(this.lclModel, 'data.userDefaultProperties', []).length === 0) {
        set(this.lclModel, 'data.userDefaultProperties', ['']);
      }
    },
    addUserProperty: function addUserProperty() {
      this.lclModel.data.userDefaultProperties = this.lclModel.data.userDefaultProperties.concat(['']);
      this.lclModel.data = cloneDeep(this.lclModel.data);
    },
    removeUserProperty: function removeUserProperty(index) {
      pullAt(this.lclModel.data.userDefaultProperties, [index]);

      if (this.lclModel.data.userDefaultProperties.length === 0) {
        this.addUserProperty();
      } // trigger a UI refresh


      this.lclModel.data.userDefaultProperties = cloneDeep(this.lclModel.data.userDefaultProperties);
    },
    handleSubmit: function handleSubmit() {
      if (!this.validate()) {
        return;
      }

      this.lclModel.data.userDefaultProperties = this.lclModel.data.userDefaultProperties.filter(function (key) {
        return key.trim() !== '';
      });

      if (this.lclModel.id) {
        this.updateTenant();
      } else if (this.referenceTenant) {
        this.createTenant();
      }
    },
    updateTenant: function updateTenant() {
      var _this7 = this;

      // to be sure, also persist the bridges if there were any changes that the user did not save
      var bridgePromise = Promise.resolve();

      if (this.$refs['bridges']) {
        bridgePromise = this.$refs['bridges'].persistBridges();
      }

      return bridgePromise.then(function () {
        return ApiService.tenantUpdate(_this7, _this7.lclModel);
      }).then(function () {
        _this7.$snack(_this7.$i18n_t('accMgmt.tenant.tenantSuccessfulUpdate'), 'success');

        _this7.$emit('modified', cloneDeep(_this7.lclModel));
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack(_this7.$i18n_t('accMgmt.tenant.tenantFailToUpdate'), 'error');
        }
      });
    },
    createTenant: function createTenant() {
      var _this8 = this;

      this.lclModel.parentId = this.referenceTenant.id;
      this.isCreatingNewTenant = true;
      return ApiService.tenantCreate(this, this.lclModel).then(function (res) {
        _this8.$store.state.app.dtwins = {};

        _this8.$snack(_this8.$i18n_t('accMgmt.tenant.tenantSuccessfulCreate'), 'success');

        _this8.$emit('created', res);
      }).catch(function (error) {
        if (error.response && _this8.$i18n_t("Error.".concat(error.response.data.message))) {
          _this8.$snack(_this8.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this8.$snack(_this8.$i18n_t('accMgmt.tenant.tenantFailToCreate'), 'error');
        }
      }).finally(function () {
        _this8.isCreatingNewTenant = false;
      });
    },
    promptSelectedTenant: function promptSelectedTenant(e) {
      this.tenantSwitchPrompt = true;
      this.tenantSwitchId = e;
    },
    fetchTenant: function fetchTenant() {
      var _this9 = this;

      var passwordPolicyPromise = ApiService.tenantGetPasswordPolicy().then(function (passwordPolicy) {
        _this9.defaultPasswordPolicy = passwordPolicy;
      });
      return passwordPolicyPromise.then(function () {
        if (_this9.referenceTenant) {
          return _this9.loadTenants(function (tenant) {
            return parseInt(tenant.id) !== parseInt(_this9.referenceTenant.id) && parseInt(tenant.parentId) !== parseInt(_this9.referenceTenant.id);
          });
        }

        return null;
      }).then(function () {
        if (_this9.referenceTenant) {
          _this9.tenantParentId = _this9.referenceTenant.parentId;
          return ApiService.tenantGetById(_this9.referenceTenant.id, ['no-scope-descendents']).then(function (tenant) {
            _this9.tenantDetails = tenant;

            _this9.revalidateForm();

            _this9.fetchServiceBuilderParams(_this9.referenceTenant.id);
          });
        }

        return null;
      }).catch(function (error) {
        if (error.response && _this9.$i18n_t("Error.".concat(error.response.data.message))) {
          _this9.$snack(_this9.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this9.$snack('Failed to fetch tenant', 'error');
        }
      });
    },
    fetchServiceBuilderParams: function fetchServiceBuilderParams(tenantId) {
      var _this10 = this;

      if (get(this.tenantDetails, 'data.serviceBuilderUrl') && this.permissions['super.system.manage']) {
        ApiService.tenantGetServiceBuilderParams(tenantId).then(function (params) {
          _this10.serviceBuilderParams = params;
        }).catch(function (error) {
          console.error(error);
        });
      } else {
        this.serviceBuilderParams = null;
      }
    }
  }
};